;(function setCookie() {
  const referralToken = location.pathname.split('/').pop()

  const daysInSeconds = 60 * 60 * 24 * 3
  const expires = new Date()

  expires.setTime(expires.getTime() + daysInSeconds * 1000)

  document.cookie = `ref=${referralToken}; expires=${expires.toUTCString()}; path=/`
})()
location.href = `/auth/registration`
